namespace advisorop.domains {

    //advisor CRUD model
    export interface IAdvisor {        

        id?: number;

        firstName?: string;

        lastName?: string;

        tin?: string;

        streetAddress1?: string;

        streetAddress2?: string;

        mailingAddress1?: string;

        mailingAddress2?: string;

        streetAddressSameAsMailingAddress?: boolean;

        advisorRole?: string;

        streetCity?: string;

        mailingCity?: string;

        streetState?: string;

        mailingState?: string;

        streetPostCode?: string;

        mailingPostCode?: string;

        streetCountryId?: string;

        mailingCountryId?: string;

        contactFirstName?: string;

        contactLastName?: string;

        contactEmail?: string;

        contactPhone?: string;

        fullName?: string;

        selectedAdvisoryLeadId?: number;

        tinForPublic?: string;    

        fullAddress?: string;

        contactFullName?: string;

        ppAdvisorId?: string;

        defaultHouseSplit?: number;

        repNumber?: string;

        useEmailAsUsername?: boolean;

        advisoryFirms?: Array<domains.IAdvisoryFirm>;

        companyGroup?: domains.ICompanyGroup;

        systemLogin?: domains.identity.IUser;  

        advisorCustodians?: Array<domains.IAdvisorCustodian>;

        advisorManagers?: Array<domains.IAdvisorManager>;

        advisorCrms?: Array<domains.IAdvisorCrm>;
    }

    export class Advisor implements IAdvisor {

        companyGroup: domains.ICompanyGroup;
        
        constructor()
        {
            // this.companyGroup = new domains.XXCompanyGroup();
            this.companyGroup = new domains.CompanyGroup();
        }        
    }

    export interface IAdminMode {
        enabled?: boolean;
        advisoryFirm?: IAdvisoryFirm;
    }

    //advisory firm CRUD model
    export interface IAdvisoryFirm {

        id?: number;

        advisoryFirmName?: string;

        firmType?: number;

        tin?: string;

        streetAddress1?: string;

        streetAddress2?: string;

        mailingAddress1?: string;

        mailingAddress2?: string;

        streetAddressSameAsMailingAddress?: boolean;

        streetCity?: string;

        mailingCity?: string;

        streetState?: string;

        mailingState?: string;

        streetPostCode?: string;

        mailingPostCode?: string;

        streetCountryId?: string;

        mailingCountryId?: string;

        defaultAdvisoryFee?: number;

        contactFirstName?: string;

        contactLastName?: string;

        contactEmail?: string;

        contactPhone?: string;

        tinForPublic?: string;

        fullAddress?: string;

        contactFullName?: string;

        //ppFirmId?: string;

        defaultAllocationPlanId?: number;

        advisors?: Array<domains.IAdvisor>;

        companyGroup?: domains.ICompanyGroup;       

        custodians?: domains.ICustodianAdvisoryFirm[];

        managers?: domains.IManagerAdvisoryFirm[];

        servicers?: domains.IServicer[];
    }

    export class AdvisoryFirm implements IAdvisoryFirm {
        advisoryFirmName: string;
    }


    //company group CRUD model
    export interface ICompanyGroup {
        id?: number;

        companyName?: string;

        streetAddress1?: string;

        streetAddress2?: string;

        mailingAddress1?: string;

        mailingAddress2?: string;

        streetAddressSameAsMailingAddress?: boolean;

        firmType?: number;

        streetCity?: string;

        mailingCity?: string;

        streetState?: string;

        mailingState?: string;

        streetPostCode?: string;

        mailingPostCode?: string;

        streetCountryId?: string;

        mailingCountryId?: string;

        contactFirstName?: string;

        contactLastName?: string;

        contactEmail?: string;

        contactPhone?: string;

        fullAddress?: string;

        contactFullName?: string;

        advisoryFirms?: Array<domains.IAdvisoryFirm>;

        ppFirmId?: string;
    }

    export class CompanyGroup implements ICompanyGroup {

        id?: number;

        companyName?: string;

        streetAddress1?: string;

        streetAddress2?: string;

        mailingAddress1?: string;

        mailingAddress2?: string;

        streetAddressSameAsMailingAddress?: boolean;

        firmType?: number;

        streetCity?: string;

        mailingCity?: string;

        streetState?: string;

        mailingState?: string;

        streetPostCode?: string;

        mailingPostCode?: string;

        streetCountryId?: string;

        mailingCountryId?: string;

        contactFirstName?: string;

        contactLastName?: string;

        contactEmail?: string;

        contactPhone?: string;

        fullAddress?: string;

        contactFullName?: string;

        advisoryFirms?: Array<domains.IAdvisoryFirm>;

        ppFirmId?: string;

        companyGroup: domains.IXXCompanyGroup;

        constructor() {
            this.companyGroup = new domains.XXCompanyGroup();
        }  
       
    }
    
    //custodians
    export interface ICustodian {
        id?: number;
        name?: string;
        ibdNumber?: string;
        status?: number;
        ordNo?: number;
        hasOfficeRanges?: boolean;
        ppCustodianId?: string;
        addressId?: number;
        phone?: string;
        address?: IAddress;
        advisoryFirms?: ICustodianAdvisoryFirm[];
        custodianDocuments?: ICustodianDocument[];
    }

    export interface IRepFeeGroupCustodian {
        id?: number;
        custodianId?: number;
        repFeeGroupId?: number;
        custodianRepCode?: string;
        custodian?: domains.ICustodian;
        repFeeGroup?: domains.IRepFeeGroup;
    }

    export interface ICustodianAdvisoryFirm {
        id?: number;
        advisoryFirmId?: number;
        custodianId?: number;
        custodianFirmId?: string;
        primaryCustodian?: boolean;
        aumBasedFeeRate?: number;
        advisoryFirm?: ICompanyGroup;
        custodian?: ICustodian;
        officeRanges?: ICustodianAdvisoryFirmOfficeRange[];
    }

    export interface IManagerAdvisoryFirm {
        id?: number;
        advisoryFirmId?: number;
        managerId?: number;
        managerFirmId?: string;
        advisoryFirm?: ICompanyGroup;
        manager?: IManager;
    }

    export interface ICustodianAdvisoryFirmOfficeRange {
        id?: number;
        custodianAdvisoryFirmId?: number;
        code?: string;
        description?: string;
        custodianAdvisoryFirm?: ICustodianAdvisoryFirm;
    }

    export interface ICustodianDocument {
        id?: number;
        custodianId?: number;
        documentId?: number;
        name?: string;
        type?: string;
        platform?: ReportingPlatform;
        uid?: string;
        documentType?: DocumentType;
     }

    export interface IAdvisorExternalSystem {
        id?: number;
        name?: string;
        description?: string;
        url?: string;
        status?: string;
    }

    export interface IAdvisorCustodian {
        id?: number;
        custodianId?: number;
        advisoryFirmId?: number;
        advisorId?: number;
        repId?: string;
        custodian?: ICustodian;
        advisoryFirm?: IAdvisoryFirm;
        status?: number;
    }

    export interface IAdvisorManager {
        id: number;
        managerId: number;
        advisoryFirmId: number;
        advisorId: number;
        repId?: string;
        manager?: IManager;
        advisoryFirm?: IAdvisoryFirm;
        status: number;
    }

    export interface IAdvisorCrm {
        id: number;
        externalSystemId?: number;
        companyGroupId?: number;
        advisorId?: number;
        externalSystemAdvisorId?: string;
    }

    export interface IAdvisorCrmViewModel {
        id: number;
        externalSystemId?: number;
        externalSystemName?: string;
        companyGroupId?: number;
        companyGroupName?: string;
        advisorId?: number;
        advisorName?: string;
        externalSystemAdvisorId?: string;
    }

    export interface IExternalSystemDataMapping {
        id: number;
        externalSystemId?: number;
        advisorOpDataFieldId?: number;
        advisorOpDataFieldString: string;
        mappingType: ExternalMappingType;
        externalDataFieldValue: string;

        externalSystem: IExternalSystem;
    }

    export interface IExternalSystem {
        id: number;
        name: string;
    }

}